class Breakpoint {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  isNotDesktop: boolean
}

export const getBreakpoint = (): Breakpoint => {
  return {
    isMobile: window.innerWidth < 640,
    isTablet: window.innerWidth >= 640 && window.innerWidth < 1024,
    isDesktop: window.innerWidth >= 1024,
    isNotDesktop: window.innerWidth < 1024
  }
}
